import properFullname from "../properFullname";

// honorifics are not shown, the postnominal is used instead
const HONORIFICS = ["dr", "dra", "atty", "engr", "mr", "mrs", "ms", "prof"];
// doctors without a postnominal, e.g., Juan A. Dela Cruz, MD
const DOCTORS = ["dr", "dra"];

const signatoryName = (fullname) => {
  const formatted = properFullname(fullname);

  if (formatted === "-") return formatted;

  const { postnominal = "", title = "" } = fullname?.fullName || fullname || {};

  // postnominal (e.g., MD, FPSP) is already part of the name
  if (postnominal || !title) return formatted;

  const _title = String(title).trim();
  const key = _title.replace(/\./g, "").toLowerCase();

  if (DOCTORS.includes(key)) return `${formatted}, MD`;
  if (HONORIFICS.includes(key)) return formatted;

  return `${formatted}, ${_title.toUpperCase()}`;
};

export default signatoryName;
